import { FC, FormEvent, PropsWithChildren, useEffect } from 'react'
import styles from './index.module.scss'
import { OutSideOverlay } from '../../atoms/OutSideOverlay'

type Props = {
  isDropDownOpen: boolean
  onInputFinished: (searchWord: string) => void
  closeDropDown: () => void
  openDropDown: () => void
  inputWaitingTime?: number
  placeholder?: string
  testid?: string
}

export const InputSearchGroupWithDropDown: FC<PropsWithChildren<Props>> = ({
  isDropDownOpen = false,
  onInputFinished,
  closeDropDown,
  openDropDown,
  children,
  inputWaitingTime = 200,
  placeholder = '',
  testid,
}) => {
  let timer
  const onChange = (e: FormEvent<HTMLInputElement>) => {
    // setTimeout の前にドロップダウンを開く
    if (!isDropDownOpen) {
      openDropDown()
    }

    if (timer) {
      clearTimeout(timer)
    }

    // inputWaitingTime ms に一回だけ検索メソッドを呼ぶために入力完了を待つ
    const value = e.currentTarget.value.trim() // 前後の空白類を削除
    timer = setTimeout(() => onInputFinished(value), inputWaitingTime)
  }

  const onFocus = (e: FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.trim() // 前後の空白類を削除
    onInputFinished(value)

    // value が空の場合、「一瞬該当の業界が見つかりません」と表示されるので一定時間待つ
    if (!isDropDownOpen) {
      setTimeout(() => openDropDown(), inputWaitingTime)
    }
  }

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [])

  return (
    <>
      {/* 検索フィールドとドロップダウンの外側 */}
      {isDropDownOpen && <OutSideOverlay onClick={() => closeDropDown()} isOpen={isDropDownOpen} />}
      <div
        className={styles.container}
        // 同じページに検索フィールドが複数ある場合
        // フィールドのドロップダウンを複数同時開くことができてしまうので (フィールドの z-index が OutSideOverlay よりも大きくなるので)
        // ドロップダウンを開いていないフィールドの z-index を 0 にする
        style={isDropDownOpen ? {} : { zIndex: 0 }}
      >
        <input
          typeof='search'
          className={styles.input}
          onChange={onChange}
          onFocus={onFocus}
          placeholder={placeholder}
          data-testid={testid}
        />
        {/* DropDown */}
        <div className={styles.dropDown}>{children}</div>
      </div>
    </>
  )
}
